import { createMediaSpec } from './media';
import { mediaInline as mediaInlineFactory } from '../../next-schema/generated/nodeTypes';

/**
 * @name mediaInline_node
 */

export const mediaInline = createMediaSpec(mediaInlineFactory({}).attrs, true);